import Footer from "@/components/Footer";
import HBIcon from "@/components/HBIcon";
import HBConfirm from "@/components/HBModal/confirm";
import Image from "@/components/Image";
import useAppStore from "@/context/store";
import FollowingCertifyList from "@/pageComponents/FollowingCertifyList";
import { getGrocery, getMuseRegisterInfo, getMyMuseStatus } from "@/services";
import { gdImgSrcPolicy } from "@/utils/imageUrl";
import useRequest from "@/utils/useReq";
import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";
import {
  useGetState,
  useMemoizedFn,
  useMount,
  useSafeState,
  useUnmount,
} from "ahooks";
import { Button, Collapse } from "antd";
import classNames from "classnames";
import Link from "next/link";
import { useRouter } from "next/router";
import { useCallback, useEffect, useRef, useState } from "react";
import { When } from "react-if";
import styles from "./index.module.less";

// const sourceTypeNameMap = {
//   0: "",
//   1: "board",
//   2: "user",
//   3: "domain",
// };

const STATUS = {
  VERIFY_FAILED: 0, // 认证失败
  NOT_MUSE: 1, // 非认证设计师
  VERIFYING: 2, // 申请审核中
  IS_MUSE: 3, // 认证通过
};

const CERTIFY_TYPE = {
  NONE: "",
  PERSONAL: "个人",
  COMPANY: "公司机构",
};

const { Panel } = Collapse;

function VipInfoQuestion({ data }) {
  const [activeKey, setActiveKey] = useState([]);
  const questionRef = useRef(null);
  const user = useAppStore((s) => s.user);

  const onChange = useCallback((activeKey) => {
    setActiveKey(activeKey);
  }, []);

  const onToggle = useCallback(
    (evt, index) => {
      if (evt?.target?.nodeName === "A") {
        return;
      }
      const contain = activeKey.includes(`${index}`);
      if (contain) {
        setActiveKey(activeKey.filter((key) => key !== `${index}`));
      } else {
        setActiveKey([...activeKey, `${index}`]);
      }
    },
    [activeKey]
  );

  useEffect(() => {
    if (data?.question) {
      const showDefaultKey = [];
      for (let i = 0; i < data?.question?.length; i++) {
        showDefaultKey.push(`${i}`);
      }
      setActiveKey(showDefaultKey);
    }
  }, [user, data]);

  return (
    <div className={styles.question} ref={questionRef}>
      <div className={styles.header}>{data?.questionTitle}</div>
      <Collapse
        className={styles.collapse}
        destroyInactivePanel={true}
        ghost={true}
        activeKey={activeKey}
        onChange={onChange}
      >
        {data?.question?.map((item, index) => (
          <Panel
            header={item?.title}
            showArrow={false}
            extra={<HBIcon className={styles.arrow} type="ic_arrow_down" />}
            key={`${index}`}
          >
            <div
              className={styles.content}
              dangerouslySetInnerHTML={{ __html: item?.content }}
              onClick={(evt) => onToggle(evt, index)}
            ></div>
          </Panel>
        ))}
      </Collapse>
      <div className={styles.more}>
        <a
          className={styles.link}
          href={data?.questionMoreLink}
          target="_blank"
          rel="noreferrer"
        >
          <div className={styles.text}>{data?.questionMoreText}</div>
          <HBIcon className={styles.icon} type="ic_chevron_right" />
        </a>
      </div>
    </div>
  );
}

export default function PageMuseRegisterTwo() {
  const router = useRouter();
  const [, setTaskId, getTaskId] = useGetState(0);
  const [submitted, setSubmitted] = useState(true);
  const [companySubmitted, setCompanySubmitted] = useState(true);
  const [current, setCurrent, getCurrent] = useGetState(0);
  const user = useAppStore((s) => s.user);
  const [data, setData] = useState({});
  const [certifyIds, setCertifyIds] = useState([]);
  const [status, setStatus] = useSafeState(STATUS.NOT_MUSE);
  const [job, setJob] = useState(CERTIFY_TYPE.NONE);
  const [refuseReason, setRefuseReason] = useState();
  const isTelPass = !!user?.tel;
  const isCompanyPinPass = user?.board_count > 5 && user?.pin_count > 50;
  const isPersonalPinPass = user?.board_count > 5 && user?.pin_count > 50;
  const isFollowerPass = user?.follower_count > 30;

  const [reCertifyStyleOnlyRead, setReCertifyStyleOnlyRead] = useState(false);

  useRequest(async () => {
    const data = await getGrocery("certify-info");
    if (data?.certifyIds) {
      const ids = [];
      data?.certifyIds.map((item) => {
        ids.push(item.id);
      });
      setCertifyIds(ids);
    }
    setData(data);
  }, [certifyIds, setData]);

  // const source = useMemo(() => {
  //   const { sourceType = "", sourceId = 0 } = router.query;

  //   return {
  //     sourceType: Object.values(sourceTypeNameMap).indexOf(sourceType),
  //     sourceId: sourceId, // 不一定是number，这边可能记录user.urlname
  //   };
  // }, [router]);

  const poll = useMemoizedFn((c) => {
    const tid = getTaskId();
    if (tid) {
      clearTimeout(tid);
      setTaskId(0);
    }
    const counter = c ?? 4;
    const newTid = setTimeout(() => {
      const cur = getCurrent();
      setCurrent((cur + 1) % 2);
      poll();
    }, counter * 1000);
    setTaskId(newTid);
    return newTid;
  });

  const onClick = (idx) => () => {
    setCurrent(idx);
    poll(10);
  };

  const init = useMemoizedFn(async () => {
    if (!user) {
      return null;
    }
    if (isTelPass && isFollowerPass && isPersonalPinPass) {
      setSubmitted(false);
    }
    if (isTelPass && isCompanyPinPass) {
      setCompanySubmitted(false);
    }

    const { isMuseUser, status, extra } = await getMyMuseStatus();
    if ([4, 1].includes(status)) {
      setStatus(STATUS.VERIFYING);
    } else if (status === 0) {
      const { refuseReason } = extra ?? {};
      setStatus(STATUS.VERIFY_FAILED);
      setRefuseReason(refuseReason);
    }
    if (isMuseUser) {
      setStatus(STATUS.IS_MUSE);
    }

    const data = (await getMuseRegisterInfo()).user;
    if (data) {
      const category = (data?.category ?? [])[0] || "";
      if (category) {
        if (category == "company") {
          setJob(CERTIFY_TYPE.COMPANY);
        } else {
          setJob(CERTIFY_TYPE.PERSONAL);
        }
      }
    }
  });

  useMount(async () => {
    poll();
  });

  useEffect(() => {
    init();
  }, [user, poll, init, setStatus]);

  useUnmount(() => {
    const tid = getTaskId();
    if (tid) {
      clearTimeout(tid);
    }
  });

  const reCertify = (url) => {
    let isPass = true;

    if (isPass && !isTelPass) {
      // title = "绑定手机号";
      isPass = false;
    }
    if (isPass && (!isPersonalPinPass || !isCompanyPinPass)) {
      // title = "画板数＞5 个 ，且采集数 > 50 张";
      isPass = false;
    }
    if (isPass && job === CERTIFY_TYPE.PERSONAL && !isFollowerPass) {
      // title = "粉丝数> 30 个";
      isPass = false;
    }
    if (!isPass) {
      HBConfirm.open({
        title: "无法重新申请",
        content: (
          <>
            <div>你当前未达到认证要求，请满足条件后再次发起申请。</div>
            <div>本次申请失败的原因是：{refuseReason}</div>
          </>
        ),
        okText: "知道了",
        hideCancelBtn: true,
      });
      setReCertifyStyleOnlyRead(true);
      return;
    }

    router.push(url);
  };

  return (
    <div className={styles.divBody}>
      <div
        className={styles.backgroundImage}
        style={{
          backgroundImage: `url(${
            gdImgSrcPolicy(
              "https://st0.dancf.com/static/02/202210260559-c2cf.png",
              { width: 1920 }
            ).src
          })`,
        }}
      ></div>
      <div className={styles.divTitleContent}>
        <div className={styles.mainTitle}>
          <div className={styles.mainImage}>
            <HBIcon
              type="Subtract"
              style={{ color: "#5068f5", fontSize: "44px" }}
            />
          </div>
          <div className={styles.mainWord}>花瓣认证</div>
        </div>
        <div className={styles.mainSubTitle}>
          专属身份标识，享多重认证权益！
        </div>
      </div>
      <div className={styles.divStatusContent}>
        <div className={styles.personalNotMuse}>
          <div
            className={styles.statusImage}
            style={{
              backgroundImage: `url(${
                gdImgSrcPolicy(
                  "https://st0.dancf.com/static/02/202210260606-a907.png"
                ).src
              })`,
            }}
          ></div>
          <div className={styles.personalTitle}>个人设计师认证</div>
          <div className={styles.personalSubTitle}>适合花瓣个人设计师申请</div>
          <div className={styles.certifyNeedInfo}>
            <div className={styles.certifyTitle}>认证要求：</div>
            <div>
              <div className={styles.certifyInfo}>
                {isTelPass ? (
                  <CheckCircleOutlined className={styles.certifyMeet} />
                ) : (
                  <CloseCircleOutlined className={styles.certifyNotMeet} />
                )}
                绑定手机号
                {!isTelPass && (
                  <a
                    style={{ marginLeft: 8, color: "#FF5967" }}
                    href={"/settings?tab=account"}
                    target={"_blank"}
                  >
                    去绑定
                  </a>
                )}
              </div>
              <div className={styles.certifyInfo}>
                {isFollowerPass ? (
                  <CheckCircleOutlined className={styles.certifyMeet} />
                ) : (
                  <CloseCircleOutlined className={styles.certifyNotMeet} />
                )}
                粉丝数&gt;30个
              </div>
              <div className={styles.certifyInfo}>
                {isPersonalPinPass ? (
                  <CheckCircleOutlined className={styles.certifyMeet} />
                ) : (
                  <CloseCircleOutlined className={styles.certifyNotMeet} />
                )}
                画板数&gt;5个，且采集数&gt;50张（包含10张以上原创作品）
              </div>
            </div>
          </div>
          {/* 个人认证入口 */}
          {/* 
            1.状态为非认证设计师时展示
            2.状态为失败，且类型为个人时候展示
          */}
          <When
            condition={
              status === STATUS.NOT_MUSE ||
              (job === CERTIFY_TYPE.COMPANY && status === STATUS.VERIFY_FAILED)
            }
          >
            <Link href={"/muse/certify"}>
              <Button
                className={submitted ? styles.btnNoneSubmit : styles.btnSubmit}
                type={"primary"}
                disabled={submitted}
              >
                申请认证
              </Button>
            </Link>
          </When>
          {status === STATUS.VERIFYING && job === CERTIFY_TYPE.PERSONAL && (
            <Button
              className={styles.btnNoneSubmit}
              type={"primary"}
              disabled={true}
            >
              已提交申请，审核中
            </Button>
          )}
          {status === STATUS.IS_MUSE && job === CERTIFY_TYPE.PERSONAL && (
            <div className={styles.divMuse}>
              <CheckCircleOutlined className={styles.certifyMeet} />
              <span className={styles.spanMuse}>
                恭喜，已获得优质设计师认证
              </span>
            </div>
          )}
          {status === STATUS.VERIFY_FAILED && job === CERTIFY_TYPE.PERSONAL && (
            <div
              className={classNames([
                styles.divFailed,
                {
                  [styles.divFailedOnlyRead]: reCertifyStyleOnlyRead,
                },
              ])}
            >
              <div style={{ float: "left" }}>
                <HBIcon
                  className={styles.icon}
                  type="error_outline"
                  style={{ marginRight: 4 }}
                />
              </div>
              <div>
                <span className={styles.spanReason}>
                  申请失败，原因：
                  <span title={refuseReason}>{refuseReason}</span>
                </span>
                <a
                  className={styles.reCertify}
                  onClick={() => {
                    reCertify("/muse/certify?force");
                  }}
                >
                  重新申请
                  <HBIcon className={styles.icon} type="ic_chevron_right" />
                </a>
              </div>
            </div>
          )}
          {/* 
            1.当状态不等于非认证设计师且不等于失败的时候，且类型为企业时候
          */}
          <When
            condition={
              status !== STATUS.NOT_MUSE &&
              status !== STATUS.VERIFY_FAILED &&
              job === CERTIFY_TYPE.COMPANY
            }
          >
            <Button
              className={styles.btnNoneSubmit}
              type={"primary"}
              disabled={true}
            >
              无法同时申请不同类型的认证
            </Button>
          </When>
        </div>
        <div className={styles.companyNotMuse}>
          <div
            className={styles.statusImage}
            style={{
              backgroundImage: `url(${
                gdImgSrcPolicy(
                  "https://st0.dancf.com/static/02/202210260615-9d11.png"
                ).src
              })`,
            }}
          ></div>
          <div
            className={classNames(styles.personalTitle, styles.companyTitle)}
          >
            企业/机构认证
          </div>
          <div
            className={classNames(
              styles.personalSubTitle,
              styles.companySubTitle
            )}
          >
            适合企业/机构申请
          </div>
          <div className={styles.certifyNeedInfo}>
            <div className={styles.certifyTitle}>认证要求：</div>
            <div>
              <div className={styles.certifyInfo}>
                {isTelPass ? (
                  <CheckCircleOutlined className={styles.certifyMeet} />
                ) : (
                  <CloseCircleOutlined className={styles.certifyNotMeet} />
                )}
                绑定手机号
                {!isTelPass && (
                  <a
                    style={{ marginLeft: 8, color: "#FF5967" }}
                    href={"/settings?tab=account"}
                    target={"_blank"}
                  >
                    去绑定
                  </a>
                )}
              </div>
              <div className={styles.certifyInfo}>
                {isCompanyPinPass ? (
                  <CheckCircleOutlined className={styles.certifyMeet} />
                ) : (
                  <CloseCircleOutlined className={styles.certifyNotMeet} />
                )}
                画板数&gt;5个，且采集数&gt;50张（原创作品更能展示企业形象）
              </div>
            </div>
          </div>
          {/* 企业认证入口 */}
          {/* 
            1.状态为非认证设计师时展示
            2.状态为失败，且类型为个人时候展示
          */}
          <When
            condition={
              status === STATUS.NOT_MUSE ||
              (status === STATUS.VERIFY_FAILED && job === CERTIFY_TYPE.PERSONAL)
            }
          >
            <Link href={"/muse/certify?type=1"}>
              <Button
                className={
                  companySubmitted ? styles.btnNoneSubmit : styles.btnSubmit
                }
                type={"primary"}
                disabled={companySubmitted}
              >
                申请认证
              </Button>
            </Link>
          </When>
          {status === STATUS.VERIFYING && job === CERTIFY_TYPE.COMPANY && (
            <Button
              className={styles.btnNoneSubmit}
              type={"primary"}
              disabled={true}
            >
              已提交申请，审核中
            </Button>
          )}
          {status === STATUS.IS_MUSE && job === CERTIFY_TYPE.COMPANY && (
            <div className={styles.divMuse}>
              <CheckCircleOutlined className={styles.certifyMeet} />
              <span className={styles.spanMuse}>恭喜，已获得优质企业认证</span>
            </div>
          )}
          {/* 当状态为失败，且类型为企业 */}
          {status === STATUS.VERIFY_FAILED && job === CERTIFY_TYPE.COMPANY && (
            <div
              className={classNames([
                styles.divFailed,
                {
                  [styles.divFailedOnlyRead]: reCertifyStyleOnlyRead,
                },
              ])}
            >
              <div style={{ float: "left" }}>
                <HBIcon
                  className={styles.icon}
                  type="error_outline"
                  style={{ marginRight: 4 }}
                />
              </div>
              <div>
                <span className={styles.spanReason}>
                  申请失败，原因：
                  <span title={refuseReason}>{refuseReason}</span>
                </span>
                <a
                  className={styles.reCertify}
                  onClick={() => {
                    reCertify("/muse/certify?type=1&force");
                  }}
                >
                  重新申请
                  <HBIcon className={styles.icon} type="ic_chevron_right" />
                </a>
              </div>
            </div>
          )}
          {/* 
            1.当状态不等于非认证设计师且不等于失败的时候，且类型为个人时候
          */}
          <When
            condition={
              status !== STATUS.NOT_MUSE &&
              status !== STATUS.VERIFY_FAILED &&
              job === CERTIFY_TYPE.PERSONAL
            }
          >
            <Button
              className={styles.btnNoneSubmit}
              type={"primary"}
              disabled={true}
            >
              无法同时申请不同类型的认证
            </Button>
          </When>
        </div>
      </div>
      <div className={styles.divGoodContent}>
        <div className={styles.titleWord}>花瓣认证专属权益</div>
        <div className={styles.description}>
          <div className={styles.titles}>
            <div
              className={classNames(styles.title, {
                [styles.current]: current === 0,
              })}
              onClick={onClick(0)}
              onMouseOver={onClick(0)}
            >
              <Image
                {...gdImgSrcPolicy(
                  "https://st0.dancf.com/static/02/202210260632-1205.png"
                )}
                width={34}
                height={34}
                alt={""}
              />
              &nbsp;&nbsp; 点亮认证标识
            </div>
            <div
              className={classNames(styles.title, {
                [styles.current]: current === 1,
              })}
              onClick={onClick(1)}
              onMouseOver={onClick(1)}
            >
              <Image
                {...gdImgSrcPolicy(
                  "https://st0.dancf.com/static/02/202210260636-d18b.png"
                )}
                width={34}
                height={34}
                alt={""}
              />
              &nbsp;&nbsp; 获得官方推荐
            </div>
            {/* <div
              className={classNames(styles.title, {
                [styles.current]: current === 2,
              })}
              onClick={onClick(2)}
              onMouseOver={onClick(2)}
            >
              <Image
                {...gdImgSrcPolicy(
                  "https://st0.dancf.com/static/02/202210260637-1bda.png"
                )}
                width={34}
                height={34}
                alt={""}
              />
              &nbsp;&nbsp; 认领设计订单
            </div> */}
          </div>

          <div className={styles.contentWrapper}>
            <div
              className={classNames(styles.content, {
                [styles.current]: current === 0,
              })}
            >
              <div className={styles.title}>
                <span className={styles.stickOut}>点亮</span>{" "}
                <span>认证标识</span>
              </div>
              <ul>
                <li>专属认证图标，提升账号权威性</li>
                <li>吸引更多关注者</li>
              </ul>

              <Image
                {...gdImgSrcPolicy(
                  "https://st0.dancf.com/static/02/202210260621-cd99.png",
                  {
                    width: 768,
                  }
                )}
                width={768}
                height={360}
                alt={""}
                style={{ top: "0px", right: "0px" }}
              />
            </div>

            <div
              className={classNames(styles.content, {
                [styles.current]: current === 1,
              })}
            >
              <div className={styles.title}>
                <span>获得</span>{" "}
                <span className={styles.stickOut}>官方推荐</span>
              </div>
              <ul>
                <li>全面流量扶持机制，优质作品更快被发现</li>
                <li>千万级曝光平台，让更多人看见你的作品</li>
              </ul>

              <Image
                {...gdImgSrcPolicy(
                  "https://cdn.dancf.com/fe-assets/20240301/75d8ca2bcc6afe8437d64273d9f4530e.png",
                  {
                    width: 768,
                  }
                )}
                width={768}
                height={360}
                alt={""}
                style={{ top: "0px", right: "0px" }}
              />
            </div>

            <div
              className={classNames(styles.content, {
                [styles.current]: current === 2,
              })}
            >
              <div className={styles.title}>
                <span>认领设计</span>{" "}
                <span className={styles.stickOut}>订单</span>
              </div>
              <ul>
                <li>官方领单机会，结算靠谱创作更安心</li>
                <li>随时随地领任务，足不出户获高收益</li>
              </ul>

              <Image
                {...gdImgSrcPolicy(
                  "https://st0.dancf.com/static/02/202210260628-3cec.png",
                  {
                    width: 768,
                  }
                )}
                width={768}
                height={360}
                alt={""}
                style={{ top: "0px", right: "0px" }}
              />
            </div>
          </div>
        </div>
      </div>
      <div className={styles.divCertifyUser}>
        <div className={styles.titleWord}>认证用户推荐</div>
        <div style={{ marginTop: 24 }}>
          <FollowingCertifyList ids={certifyIds} />
        </div>
      </div>
      <VipInfoQuestion data={data} />
      <Footer />
    </div>
  );
}
